import { Link } from 'react-router-dom';
import { SignupForm } from 'features/auth/components/signup-form';
import darklogo from 'assets/images/bebrave-logo.svg';
import lightlogo from 'assets/images/bebrave-logo.svg';
import { useTheme } from 'components/core/theme-provider';
import { useGetLoginOptions } from 'features/auth/hooks/use-auth';
import { GRANT_TYPES } from 'constant/auth';
import { SsoSignin } from '../signin/signin-sso';
import { useTranslation } from 'react-i18next';

export function SignupPage() {
  const { theme } = useTheme();
  const { data: loginOption } = useGetLoginOptions();

  const socialGrantAllowed = loginOption?.allowedGrantTypes?.includes(GRANT_TYPES.social);

  return (
    <div className="flex flex-col">
      <Logo theme={theme} />
      <SignupHeader />
      <SignupForm />
      {socialGrantAllowed && loginOption && <SsoSignin loginOption={loginOption} />}
    </div>
  );
}

type LogoProps = Readonly<{
  theme: string;
}>;

function Logo({ theme }: LogoProps) {
  return (
    <div className="w-14 h-14 mb-2">
      <img src={theme === 'dark' ? darklogo : lightlogo} className="w-full h-full" alt="logo" />
    </div>
  );
}

function SignupHeader() {
  const { t } = useTranslation();

  return (
    <div>
      <h2 className="text-xl font-bold text-high-emphasis">{t('SIGN_UP_ACCESS_OPEN_SOURCE')}</h2>
      <div className="flex items-center gap-1 my-4">
        <span className="text-sm font-normal text-medium-emphasis">
          {t('ALREADY_HAVE_ACCOUNT')}
        </span>
        <Link
          to={'/login'}
          className="text-sm font-bold text-primary hover:text-primary-600 hover:underline"
        >
          {t('LOG_IN')}
        </Link>
      </div>
    </div>
  );
}

type DividerProps = Readonly<{
  text: string;
}>;

export function Divider({ text }: DividerProps) {
  return (
    <div className="flex items-center gap-4 mb-4">
      <div className="flex-1">
        <hr className="h-[2px] bg-gray-200 border-0 rounded" />
      </div>
      <div className="text-base font-normal text-low-emphasis">{text}</div>
      <div className="flex-1">
        <hr className="h-[2px] bg-gray-200 border-0 rounded" />
      </div>
    </div>
  );
}
